import React from "react";

const SubstringWithDot = ({stringData, numberChar, classNames}) => {

    return stringData && (
        <div className={classNames ? classNames : ''}>
            { stringData.length > numberChar ? (
                <span>{ stringData.substring(0, numberChar) } ...</span>
            ) : (
                <span> { stringData } </span>
            ) }
        </div>
    )

};
export default SubstringWithDot;
